<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('exam_definitions')" :is-filter="false" />
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('exam_definitions')" :is-filter="false" />
            </template>
            <div class="row">
                <div class="col-12 col-lg-3 col-xxl-3 mb-3 mb-md-3 mb-lg-0">
                    <div>
                        <b-form-group :label="$t('semester')">
                            <semesters-selectbox v-model="filterSemester" :setActive="true"></semesters-selectbox>
                        </b-form-group>
                        <b-form-group :label="$t('course_code')">
                            <b-form-input v-model="filterSection"></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="border p-4 rounded overflow-y-scroll overflow-x-hidden w-100 d-lg-block"
                        style="height: calc(100vh - 230px); min-height: 300px; max-height: `${innerHeight}px`; overflow-y: scroll">
                        <div>
                            <div v-if="isClass === true">
                                <div class="course" v-for="(item, key) in filterSetClass"
                                    :class="selectedCourse === item.section_id ? 'selected-item' : ''"
                                    :id="'course-' + item.section_id" :ref="'course-' + item.section_id" :key="key" @click="() => {
                                        selectedCourse = item.section_id
                                        getExamDefinitions(item.section_id, item.course_name)
                                    }">
                                    <div class="name">
                                        {{ item.course_name }}
                                    </div>
                                    <div class="other">
                                        <b-badge variant="dark">
                                            {{ $t('section_1') }} :{{ item.section }}
                                        </b-badge>
                                        <b-badge variant="dark" class="ml-2">
                                            {{ item.course_code }}
                                        </b-badge>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="spinner-border text-light mx-auto d-flex"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-9 col-xxl-9 mt-1 mt-lg-0" v-if="tableStatus == 'examDefinition'">
                    <template>
                        <ExamDefinitionTable :courseName="course_name" @setExamType="setExamType"
                            @tableStatusUpdate="tableStatusUpdate" :section_id="section_id" />
                    </template>
                </div>
                <div class="col-12 col-lg-9 col-xxl-9 mt-1 mt-lg-0" v-if="tableStatus == 'exam'">
                    <template>
                        <ExamsTable :examId="examId" :examTypeText="examTypeText" :examType="examType" :courseName="course_name" :section_id="section_id" :threshold_value="threshold_value"
                            :numberOfExams="numberOfExams" :effectRatio="effectRatio" @tableStatusUpdate="tableStatusUpdate" />
                    </template>
                </div>
            </div>
        </app-layout>
    </div>
</template>
<script>
// Template
import AppLayout from '@/layouts/AppLayout';
import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'
import AttendanceEntryService from "@/services/AttendanceEntryService";
import ExamDefinitionTable from "@/modules/UNIVERSITY/BATUM/examDefinitions/pages/ExamDefinitionTable/ExamDefinitionTable.vue";
import ExamsTable from "@/modules/UNIVERSITY/BATUM/examDefinitions/pages/examTable/ExamTable.vue";
import ParameterSelectbox from '@/components/interactive-fields/ParameterSelectbox';

export default {
    name: "ExamDefinitions",
    components: {
        ExamDefinitionTable,
        AppLayout,
        HeaderMobile,
        ExamsTable,
        ParameterSelectbox,
    },
    metaInfo() {
        return {
            title: this.$t('exam_definitions')
        };
    },
    data() {
        return {
            filterSection: "",
            filterSemester: null,
            examDefinitionId: null,
            course_name: null,
            section_id: null,
            selectedCourse: null,
            setClass: [],
            isClass: false,
            examId: null,
            examTypeText: null,
            examType: null,
            numberOfExams: null,
            effectRatio: null,
            threshold_value: null,
            tableStatus: "examDefinition"
        };
    },
    watch: {
        // filterSemester her değiştiğinde bu fonksiyon çalışır
        filterSemester(newVal) {
            if (newVal) {
                this.setModule(newVal);
            }
        }
    },
    computed: {
        filterSetClass() {
            let filtered = this.setClass;

            if (this.filterSection) {
                filtered = filtered.filter(item =>
                    item.course_name.toLowerCase().includes(this.filterSection.toLowerCase()) ||
                    item.course_code.toLowerCase().includes(this.filterSection.toLowerCase())
                );
            }

            return filtered;
        },
        innerHeight() {
            return window.innerHeight
        }
    },
    created() {
        this.setModule()
    },
    methods: {
        setExamType({ examTypeText, examId, number_of_exams, effect_ratio, exam_type, threshold_value }) {
            this.examId = examId
            this.examTypeText = examTypeText
            this.examType = exam_type
            this.numberOfExams = number_of_exams
            this.effectRatio = effect_ratio
            this.threshold_value = threshold_value
            this.tableStatus = 'exam'
        },
        tableStatusUpdate(value) {
            this.tableStatus = value
        },
        getExamDefinitions(section_id, course_name) {
            this.tableStatus = 'examDefinition'
            this.section_id = section_id
            this.course_name = course_name
            this.setModule(this.filterSemester)
        },
        setModule(semesterId = null) {
            this.isClass = false;

            let config = {
                params: {}
            };
            if(semesterId){
                config.params.semester_id = semesterId;
            }
            AttendanceEntryService.getAll(config).then((response) => {
                this.isClass = true;
                this.setClass = response.data.data;
            }).catch(err => {
                this.isClass = true;
                this.setClass = [];
            });
        },

    }
}
</script>
<style scoped>
.course {
    border-radius: 5px;
    height: 100%;
    border: 1px solid #e9ecef;
    padding: 10px;
    margin-bottom: 10px;
}

.course .name {
    font-size: 16px;
    margin-bottom: 20px;
}

.selected-item {
    background: #00aeef !important;
    color: #fff !important;
}
</style>

